//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'HeightAndHeightPercentileOfInfants',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: ''
      },
      dataList1: [
        { name: '男', value: '0' },
        { name: '女', value: '1' }
      ],
      dataList2: [],
      comparisontable0: [
        {
          'p3': 2,
          'p25': 2.2,
          'p75': 2.5,
          'p97': 2.7
        },
        {
          'p3': 2.1,
          'p25': 2.4,
          'p75': 2.7,
          'p97': 3
        },
        {
          'p3': 2.3,
          'p25': 2.5,
          'p75': 2.9,
          'p97': 3.2
        },
        {
          'p3': 2.5,
          'p25': 2.7,
          'p75': 3.1,
          'p97': 3.4
        },
        {
          'p3': 2.6,
          'p25': 2.9,
          'p75': 3.3,
          'p97': 3.7
        },
        {
          'p3': 2.8,
          'p25': 3.1,
          'p75': 3.5,
          'p97': 3.9
        },
        {
          'p3': 3,
          'p25': 3.3,
          'p75': 3.7,
          'p97': 4.2
        },
        {
          'p3': 3.2,
          'p25': 3.5,
          'p75': 4,
          'p97': 4.5
        },
        {
          'p3': 3.4,
          'p25': 3.8,
          'p75': 4.3,
          'p97': 4.8
        },
        {
          'p3': 3.7,
          'p25': 4.1,
          'p75': 4.6,
          'p97': 5.1
        },
        {
          'p3': 3.9,
          'p25': 4.3,
          'p75': 4.9,
          'p97': 5.5
        },
        {
          'p3': 4.2,
          'p25': 4.6,
          'p75': 5.2,
          'p97': 5.8
        },
        {
          'p3': 4.4,
          'p25': 4.9,
          'p75': 5.5,
          'p97': 6.2
        },
        {
          'p3': 4.7,
          'p25': 5.2,
          'p75': 5.8,
          'p97': 6.5
        },
        {
          'p3': 4.9,
          'p25': 5.5,
          'p75': 6.1,
          'p97': 6.9
        },
        {
          'p3': 5.2,
          'p25': 5.7,
          'p75': 6.5,
          'p97': 7.2
        },
        {
          'p3': 5.4,
          'p25': 6,
          'p75': 6.8,
          'p97': 7.6
        },
        {
          'p3': 5.7,
          'p25': 6.3,
          'p75': 7.1,
          'p97': 7.9
        },
        {
          'p3': 5.9,
          'p25': 6.6,
          'p75': 7.4,
          'p97': 8.2
        },
        {
          'p3': 6.2,
          'p25': 6.8,
          'p75': 7.7,
          'p97': 8.6
        },
        {
          'p3': 6.4,
          'p25': 7.1,
          'p75': 7.9,
          'p97': 8.9
        },
        {
          'p3': 6.6,
          'p25': 7.3,
          'p75': 8.2,
          'p97': 9.2
        },
        {
          'p3': 6.9,
          'p25': 7.5,
          'p75': 8.5,
          'p97': 9.5
        },
        {
          'p3': 7.1,
          'p25': 7.8,
          'p75': 8.7,
          'p97': 9.8
        },
        {
          'p3': 7.3,
          'p25': 8,
          'p75': 9,
          'p97': 10
        },
        {
          'p3': 7.5,
          'p25': 8.2,
          'p75': 9.2,
          'p97': 10.3
        },
        {
          'p3': 7.7,
          'p25': 8.4,
          'p75': 9.4,
          'p97': 10.6
        },
        {
          'p3': 7.9,
          'p25': 8.6,
          'p75': 9.7,
          'p97': 10.8
        },
        {
          'p3': 8.1,
          'p25': 8.8,
          'p75': 9.9,
          'p97': 11
        },
        {
          'p3': 8.2,
          'p25': 9,
          'p75': 10,
          'p97': 11.3
        },
        {
          'p3': 8.4,
          'p25': 9.2,
          'p75': 10.3,
          'p97': 11.5
        },
        {
          'p3': 8.6,
          'p25': 9.4,
          'p75': 10.5,
          'p97': 11.7
        },
        {
          'p3': 8.8,
          'p25': 9.6,
          'p75': 10.7,
          'p97': 12
        },
        {
          'p3': 8.9,
          'p25': 9.8,
          'p75': 10.9,
          'p97': 12.2
        },
        {
          'p3': 9.1,
          'p25': 10,
          'p75': 11.1,
          'p97': 12.4
        },
        {
          'p3': 9.3,
          'p25': 10.1,
          'p75': 11.3,
          'p97': 12.6
        },
        {
          'p3': 9.5,
          'p25': 10.3,
          'p75': 11.5,
          'p97': 12.8
        },
        {
          'p3': 9.6,
          'p25': 10.5,
          'p75': 11.7,
          'p97': 13
        },
        {
          'p3': 9.8,
          'p25': 10.7,
          'p75': 11.9,
          'p97': 13.3
        },
        {
          'p3': 10,
          'p25': 10.9,
          'p75': 12.1,
          'p97': 13.5
        },
        {
          'p3': 10.2,
          'p25': 11.1,
          'p75': 12.3,
          'p97': 13.7
        },
        {
          'p3': 10.4,
          'p25': 11.3,
          'p75': 12.6,
          'p97': 14
        },
        {
          'p3': 10.6,
          'p25': 11.5,
          'p75': 12.8,
          'p97': 14.2
        },
        {
          'p3': 10.8,
          'p25': 11.7,
          'p75': 13,
          'p97': 14.4
        },
        {
          'p3': 11,
          'p25': 11.9,
          'p75': 13.2,
          'p97': 14.7
        },
        {
          'p3': 11.2,
          'p25': 12.1,
          'p75': 13.5,
          'p97': 15
        },
        {
          'p3': 11.4,
          'p25': 12.4,
          'p75': 13.7,
          'p97': 15.2
        },
        {
          'p3': 11.6,
          'p25': 12.6,
          'p75': 13.9,
          'p97': 15.5
        },
        {
          'p3': 11.8,
          'p25': 12.8,
          'p75': 14.2,
          'p97': 15.8
        },
        {
          'p3': 12,
          'p25': 13,
          'p75': 14.4,
          'p97': 16
        },
        {
          'p3': 12.2,
          'p25': 13.2,
          'p75': 14.7,
          'p97': 16.2
        },
        {
          'p3': 12.4,
          'p25': 13.5,
          'p75': 15,
          'p97': 16.6
        },
        {
          'p3': 12.6,
          'p25': 13.7,
          'p75': 15.2,
          'p97': 16.8
        },
        {
          'p3': 12.9,
          'p25': 14,
          'p75': 15.4,
          'p97': 17.1
        },
        {
          'p3': 13.1,
          'p25': 14.2,
          'p75': 15.7,
          'p97': 17.4
        },
        {
          'p3': 13.3,
          'p25': 14.5,
          'p75': 16,
          'p97': 17.7
        }
      ],
      comparisontable1: [
        {
          'p3': 2,
          'p25': 2.2,
          'p75': 2.5,
          'p97': 2.8
        },
        {
          'p3': 2.1,
          'p25': 2.4,
          'p75': 2.7,
          'p97': 3
        },
        {
          'p3': 2.3,
          'p25': 2.6,
          'p75': 2.9,
          'p97': 3.2
        },
        {
          'p3': 2.5,
          'p25': 2.7,
          'p75': 3.1,
          'p97': 3.4
        },
        {
          'p3': 2.6,
          'p25': 2.9,
          'p75': 3.3,
          'p97': 3.6
        },
        {
          'p3': 2.8,
          'p25': 3.1,
          'p75': 3.5,
          'p97': 3.9
        },
        {
          'p3': 3,
          'p25': 3.3,
          'p75': 3.7,
          'p97': 4.2
        },
        {
          'p3': 3.2,
          'p25': 3.6,
          'p75': 4,
          'p97': 4.5
        },
        {
          'p3': 3.4,
          'p25': 3.8,
          'p75': 4.3,
          'p97': 4.8
        },
        {
          'p3': 3.7,
          'p25': 4.1,
          'p75': 4.6,
          'p97': 5.1
        },
        {
          'p3': 3.9,
          'p25': 4.3,
          'p75': 4.9,
          'p97': 5.4
        },
        {
          'p3': 4.2,
          'p25': 4.6,
          'p75': 5.2,
          'p97': 5.8
        },
        {
          'p3': 4.4,
          'p25': 4.8,
          'p75': 5.5,
          'p97': 6.1
        },
        {
          'p3': 4.6,
          'p25': 5.1,
          'p75': 5.7,
          'p97': 6.4
        },
        {
          'p3': 4.9,
          'p25': 5.4,
          'p75': 6,
          'p97': 6.8
        },
        {
          'p3': 5.1,
          'p25': 5.6,
          'p75': 6.3,
          'p97': 7.1
        },
        {
          'p3': 5.3,
          'p25': 5.9,
          'p75': 6.6,
          'p97': 7.4
        },
        {
          'p3': 5.6,
          'p25': 6.1,
          'p75': 6.9,
          'p97': 7.7
        },
        {
          'p3': 5.8,
          'p25': 6.4,
          'p75': 7.2,
          'p97': 8
        },
        {
          'p3': 6,
          'p25': 6.6,
          'p75': 7.4,
          'p97': 8.3
        },
        {
          'p3': 6.2,
          'p25': 6.9,
          'p75': 7.7,
          'p97': 8.6
        },
        {
          'p3': 6.5,
          'p25': 7.1,
          'p75': 7.9,
          'p97': 8.9
        },
        {
          'p3': 6.7,
          'p25': 7.3,
          'p75': 8.2,
          'p97': 9.2
        },
        {
          'p3': 6.9,
          'p25': 7.5,
          'p75': 8.4,
          'p97': 9.4
        },
        {
          'p3': 7.1,
          'p25': 7.7,
          'p75': 8.7,
          'p97': 9.7
        },
        {
          'p3': 7.2,
          'p25': 7.9,
          'p75': 8.9,
          'p97': 9.9
        },
        {
          'p3': 7.4,
          'p25': 8.1,
          'p75': 9.1,
          'p97': 10.2
        },
        {
          'p3': 7.6,
          'p25': 8.3,
          'p75': 9.3,
          'p97': 10.4
        },
        {
          'p3': 7.8,
          'p25': 8.5,
          'p75': 9.5,
          'p97': 10.6
        },
        {
          'p3': 8,
          'p25': 8.7,
          'p75': 9.7,
          'p97': 10.9
        },
        {
          'p3': 8.1,
          'p25': 8.9,
          'p75': 9.9,
          'p97': 11.1
        },
        {
          'p3': 8.3,
          'p25': 9.1,
          'p75': 10.1,
          'p97': 11.3
        },
        {
          'p3': 8.5,
          'p25': 9.3,
          'p75': 10.3,
          'p97': 11.5
        },
        {
          'p3': 8.6,
          'p25': 9.4,
          'p75': 10.5,
          'p97': 11.7
        },
        {
          'p3': 8.8,
          'p25': 9.6,
          'p75': 10.7,
          'p97': 11.9
        },
        {
          'p3': 9,
          'p25': 9.8,
          'p75': 10.9,
          'p97': 12.2
        },
        {
          'p3': 9.2,
          'p25': 10,
          'p75': 11.1,
          'p97': 12.4
        },
        {
          'p3': 9.3,
          'p25': 10.2,
          'p75': 11.3,
          'p97': 12.6
        },
        {
          'p3': 9.5,
          'p25': 10.4,
          'p75': 11.5,
          'p97': 12.8
        },
        {
          'p3': 9.7,
          'p25': 10.6,
          'p75': 11.8,
          'p97': 13.1
        },
        {
          'p3': 9.9,
          'p25': 10.8,
          'p75': 12,
          'p97': 13.3
        },
        {
          'p3': 10.1,
          'p25': 11,
          'p75': 12.2,
          'p97': 13.6
        },
        {
          'p3': 10.3,
          'p25': 11.2,
          'p75': 12.4,
          'p97': 13.8
        },
        {
          'p3': 10.5,
          'p25': 11.4,
          'p75': 12.7,
          'p97': 14.1
        },
        {
          'p3': 10.7,
          'p25': 11.6,
          'p75': 12.9,
          'p97': 14.3
        },
        {
          'p3': 10.9,
          'p25': 11.8,
          'p75': 13.1,
          'p97': 14.6
        },
        {
          'p3': 11.1,
          'p25': 12,
          'p75': 13.4,
          'p97': 14.8
        },
        {
          'p3': 11.3,
          'p25': 12.3,
          'p75': 13.6,
          'p97': 15.1
        },
        {
          'p3': 11.5,
          'p25': 12.5,
          'p75': 13.8,
          'p97': 15.4
        },
        {
          'p3': 11.7,
          'p25': 12.7,
          'p75': 14.1,
          'p97': 15.7
        },
        {
          'p3': 11.9,
          'p25': 12.9,
          'p75': 14.4,
          'p97': 16
        },
        {
          'p3': 12.1,
          'p25': 13.2,
          'p75': 14.6,
          'p97': 16.3
        },
        {
          'p3': 12.4,
          'p25': 13.4,
          'p75': 14.9,
          'p97': 16.6
        },
        {
          'p3': 12.6,
          'p25': 13.7,
          'p75': 15.2
        },
        {
          'p3': 12.8,
          'p25': 14,
          'p75': 15.5,
          'p97': 17.2
        },
        {
          'p3': 13.1,
          'p25': 14.2,
          'p75': 15.8,
          'p97': 17.5
        }
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
    this.init()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    init () {
      for (let i = 45; i < 101; i++) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dataList2.push({
          name: String(i), value: String(i - 45)
        })
      }
    },
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.comparisontable0.length, 777)
      let form = JSON.parse(JSON.stringify(self.form))
      if (form.data3 > 30 || form.data3 < 0) return
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        return ''
      }
      let result = form.data3
      console.log(form, 666)
      const comparisontable = self['comparisontable' + form.data1][form.data2]
      console.log(comparisontable, 888)
      if (result <= comparisontable.p3) {
        self.descTxt = '评价等级:下(P3)'
      } else if (result >= comparisontable.p3 && result < comparisontable.p25) {
        self.descTxt = '评价等级:中下(P3-P25)'
      } else if (result >= comparisontable.p25 && result < comparisontable.p75) {
        self.descTxt = '评价等级:中(P25-P75)'
      } else if (result >= comparisontable.p75 && result < comparisontable.p97) {
        self.descTxt = '评价等级:中上(P75-P97)'
      } else if (result >= comparisontable.p97) {
        self.descTxt = '评价等级:上(P97)'
      }

      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/HeightAndHeightPercentileOfInfants.vue